/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TagsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABIklEQVR4nM2VMU7DUAyGuwM7YuACcI0OQGz/HV7tAQEHQOyUIb0IN+A2LAiBkEAMTEg9QEGvJCBCUl6cBmHJS5R8n/N+RxkM/kMR7JhFbxk2Z9hbtQn6TNDMBxed1kF/tNh1ZzhBXwl6uh/CpmvapXDRl4PReLczOAVOv2Ui+pRB93xwScuEYI+9wbnolcEJdj4cHq6R6KRWQKInVTiR7aROHkJYj/cx80aDwO68cP54ZhIlDL2oF8BmxavOupw5N2XA0KvFxZGdrQrOsPmXgG2LRC/Ls6xmwo4m2E3td1DNhL3N46NmQZGJe3rRaSP8WyboAf6ZCeyhF3hZWRa2WfS+hSBPhjskeWt4C0nuhidIusPLisHH7VqscPzZLNvzv6x3CDI+OhBlk/gAAAAASUVORK5CYII=)
 */
export const TagsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.12 1.88A3 3 0 0 1 11.24 1H17a2 2 0 0 1 1.94 1.5c.07.27-.16.5-.44.5h-4.26a4 4 0 0 0-2.83 1.17l-7.25 7.25c-.5.51-.85 1.12-1.03 1.77-.12.45-.74.7-1.06.38l-.2-.2a3 3 0 0 1 0-4.24l7.25-7.25Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M13.12 5.88A3 3 0 0 1 15.24 5H21a2 2 0 0 1 2 2v5.76a3 3 0 0 1-.88 2.12l-7.25 7.25a3 3 0 0 1-4.24 0l-4.76-4.76a3 3 0 0 1 0-4.24l7.25-7.25ZM20 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
